import * as React from "react";
const SvgFiRrTurntable = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M10 6c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6m0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m9-14H5C2.243 2 0 4.243 0 7v10c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5m3 15c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zM20 7v5.679c0 .682-.136 1.344-.404 1.97l-1.177 2.745a1 1 0 1 1-1.838-.787l1.177-2.745q.242-.566.242-1.183V7a1 1 0 1 1 2 0m-8.5 5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 11.5 12"
    />
  </svg>
);
export default SvgFiRrTurntable;
